module.exports = __webpack_public_path__ + "media/entities/1119-53aa726c.png";